import {Modal} from 'react-bootstrap'
import {connect} from 'react-redux'
import {reduxForm, formValueSelector, Field, change} from 'redux-form'
import styles from './SetQuantityModal.css'

class SetQuantityModal extends React.Component {
  componentWillReceiveProps (nextProps) {
    if (nextProps.open && nextProps.open !== this.props.open) {
      $('.modal-backdrop.in').css('z-index', '1056')
    }
  }

  render () {
    return (<Modal show={this.props.open} onExit={this._onHide} onEnter={this._setZindex} dialogClassName={`${styles['modal-dialog-set-quantity']} ${styles.dialog} modal-dialog-set-quantity`}>
      <form onSubmit={this.props.handleSubmit}>
        <Modal.Body bsClass={`modal-body ${styles['modal-body']}`}>
          <p className={styles.header}>Set Quantity</p>
          <p>{this._itemName()}</p>
          <div className={`input-group ${styles['qty-field']}`}>
            <span className={`input-group-addon ${styles['btn-add']} ${styles['btn-inc']}`} onClick={() => this._incrementQty(-1)}>
              <i className='fa fa-minus' />
            </span>
            <Field
              type='text'
              component='input'
              name='quantity'
              className={`form-control ${styles.quantity}`}
              disabled
            />
            <span className={`input-group-addon ${styles['btn-add']} ${styles['btn-dec']}`} onClick={() => this._incrementQty(1)}>
              <i className='fa fa-plus' />
            </span>

            <Field
              type='hidden'
              component='input'
              name='idx'
            />
          </div>
        </Modal.Body>
        <Modal.Footer bsClass={`${styles.footer} modal-footer`}>
          <button onClick={this._onClickCancel} className={`btn btn-link ${styles['btn-cancel']}`}>Cancel</button>
          <button type='submit' className={`btn btn-link ${styles['btn-set']}`}>Set</button>
        </Modal.Footer>
      </form>
    </Modal>)
  }

  _setZindex = () => {
    $('.modal-dialog-set-quantity').parent().css('z-index', '1057')
  }

  _onHide = () => {
    $('.modal-backdrop.fade.in').css('z-index', '499')
    $('.modal-dialog-set-quantity').parent().css('z-index', '1057')
  }

  _itemName = () => {
    const {idx, refundItems} = this.props
    if (!idx && idx !== 0) {
      return false
    } else {
      return refundItems[idx].itemName
    }
  };

  _onClickCancel = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.props.onCancel()
  }

  _incrementQty = (value) => {
    const {idx, refundItems, quantity, dispatch} = this.props
    const refundItem = refundItems[idx]
    if (idx === undefined) {
      return false
    } else if (quantity + value < 1) {
      return false
    } else if (quantity + value > refundItem.maxQuantity) {
      return false
    } else {
      dispatch(change('setQuantity', 'quantity', quantity + value))
    }
  }
}

SetQuantityModal.propTypes = {
  onCancel: React.PropTypes.func
}

const selector = formValueSelector('setQuantity')

function mapStateToProps (state) {
  return {
    quantity: selector(state, 'quantity'),
    idx: selector(state, 'idx')
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'setQuantity'
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(SetQuantityModal))



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/SetQuantityModal/SetQuantityModal.js